// import { v4 as uuid } from "uuid";

export const categories = [
  {
    _id: "0d8fae69-56f3-45f6-be42-a1dd6349192e",
    categoryName: "Topwear",
    description: "",
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-cotton-racerback-tank-top-1-355314.jpg",
  },
  {
    _id: "52d08ba9-3334-47cd-894a-75f8fa7d1169",
    categoryName: "Bottomwear",
    description: "",
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-lb0139a19-479514.jpg",
  },
  {
    _id: "5a64ca61-20a5-4c59-8464-6e8e9d1b9480",
    categoryName: "Loungewear",
    description: "Check out our best Lounge Wear Collection",
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ls0592r03-589836.jpg",
  },
  {
    _id: "4284fd37-df10-4402-83ca-848800384c3d",
    categoryName: "Nightsuit",
    description: "",
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ls0680a08-624984.jpg",
  },
  {
    _id: "796087fa-b6dc-4fdd-8171-2089bc04fbf6",
    categoryName: "Nightdress",
    description: "",
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-chic-basic-robe-short-nighty-set-in-rust-brown-satin-896300.jpg",
  },
];
